import axios from 'axios';
import config from '../config';

export interface BrandSupplierMapping {
  brandId: number;
  brandName: string;
  supplierId: number;
  supplierName: string;
}

export interface BrandSupplierOption {
  supplierId: number;
  supplierName: string;
}

const headers = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : undefined;
};

const API = `${config.API_URL}/brand-suppliers`;

export async function fetchBrandSupplierMappings(): Promise<
  BrandSupplierMapping[]
> {
  const response = await axios.get<BrandSupplierMapping[]>(API, {
    headers: headers(),
  });
  return response.data;
}

export async function fetchBrandSupplierOptions(): Promise<
  BrandSupplierOption[]
> {
  const response = await axios.get<BrandSupplierOption[]>(`${API}/suppliers`, {
    headers: headers(),
  });
  return response.data;
}

export async function saveBrandSupplierMapping(payload: {
  brandId?: number;
  brandName: string;
  supplierId: number;
}): Promise<BrandSupplierMapping> {
  const { brandId, ...body } = payload;
  const response = brandId
    ? await axios.put<BrandSupplierMapping>(`${API}/${brandId}`, body, {
        headers: headers(),
      })
    : await axios.post<BrandSupplierMapping>(API, body, { headers: headers() });
  return response.data;
}

export async function removeBrandSupplierMapping(
  brandId: number,
): Promise<void> {
  await axios.delete(`${API}/${brandId}`, { headers: headers() });
}
